@if (isOpen()) {
  <div class="modal-overlay" (click)="onOverlayClick($event)">
    <div class="modal-content" (click)="$event.stopPropagation()">
      @if (title() || showClose()) {
        <div class="modal-header">
          <div class="modal-header-text">
            @if (title()) {
              <h3 class="modal-title">{{ title() }}</h3>
            }
            @if (description()) {
              <p class="modal-description">{{ description() }}</p>
            }
          </div>
          @if (showClose()) {
            <button class="modal-close" (click)="onClose()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }

      <div class="modal-body">
        <ng-content></ng-content>
      </div>

      <div class="modal-footer">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
}
